/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const physicalInfrastructureEnumsPotentialConsequenceOptionEnum = {
    SLARisk: 'SLARisk',
    RedundancyLoss: 'RedundancyLoss',
    Outage: 'Outage',
    Other: 'Other',
} as const;

export type PhysicalInfrastructureEnumsPotentialConsequenceOptionEnumKey =
    (typeof physicalInfrastructureEnumsPotentialConsequenceOptionEnum)[keyof typeof physicalInfrastructureEnumsPotentialConsequenceOptionEnum];

export type PhysicalInfrastructureEnumsPotentialConsequenceOption =
    PhysicalInfrastructureEnumsPotentialConsequenceOptionEnumKey;
